<template>
  <div class="ui modal" :id="'edit-lesson-modal-' + _uid">
    <div class="header">Short Name: {{ currentLesson.data.shortName }}</div>
    <div class="scrolling content">
      <div class="ui form">
        <div class="field">
          <div class="required field">
            <label>Lesson Title</label>
            <input v-model="currentLesson.data.title"
                   name="title" type="text" placeholder="e.g. Article Title">
          </div>

          <div class="field">
            <label>Lesson Description</label>
            <quill-editor v-model="currentLesson.data.body"></quill-editor>
          </div>

          <br>

          <div class="required three wide field">
            <label>Start Day</label>
            <input v-model="currentLesson.data.options.startDay"
                   name="start-day" type="number" style="display:inline-block; width:100px !important" maxlength="3">
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui left floated button" @click="resetSelection">Cancel</div>
      <div class="ui button" @click="updateSelectedLesson">Save</div>
    </div>
  </div>
</template>

<script>
  import { quillEditor } from 'vue-quill-editor'
	export default {
	  props:{
	    selectedLesson: {
	      type: Object,
        required: true
      }
    },
    components: {
	    quillEditor
    },
		data() {
			return {
        currentLesson: JSON.parse(JSON.stringify(this.selectedLesson)),
        validationStatus: null,
        modalId: '#edit-lesson-modal-' + this._uid
      }
		},
		computed: {

    },
		methods: {
      resetSelection: function() {
        $(this.modalId).form('reset');
        this.currentLesson = JSON.parse(JSON.stringify(this.selectedLesson));
        $(this.modalId).modal('hide');
      },

      updateSelectedLesson: function(){
        // Emit upwards to update this specific action
        if (this.validateForm() === true){
          let payload = this.currentLesson;
          this.$emit('updateUserLessons', payload);
          $(this.modalId).modal('hide');
        }
        else {
          $(this.modalId).form('validate form');
        }
      },

      validateForm: function() {
        return $(this.modalId).form('validate form');
      },

      initFormValidation() {
        $(this.modalId).form({
          fields: {
            'title': {
              identifier: 'title',
              rules: [
                {type: 'empty', prompt: 'Lesson Plan Title cannot be empty'}
              ]
            },
            'start-day': {
              // For the relevant rule to show, do not change the order of the `rules` array
              identifier: 'start-day',
              rules: [
                {type: 'not[-0]', prompt: 'Enter a valid, positive whole number'},
                {type: 'doesntContain[-]', prompt: 'Start Day cannot be negative'},
                {type: 'not[0]', prompt: 'Start Day cannot be 0'},
                {type: 'integer', prompt: 'Start Day must be whole number'},
                {type: 'integer[1..300]', prompt: 'Start Day must be a whole number between 1 to 300'}
              ]
            }
          },
          inline: true
        });
      },
    },
    watch: {
	    selectedLesson: function() {
        this.currentLesson = JSON.parse(JSON.stringify(this.selectedLesson));
      },
    },
		mounted() {
      this.initFormValidation();
    },
    beforeDestroy() {
      let modal = document.querySelector(this.modalId);
      if (modal !== null) {
        modal.remove();
      }
    }
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/patients/PatientLessonPlanEditModal.vue